import { render } from "./JFpublish.vue?vue&type=template&id=d860830e&scoped=true"
import script from "./JFpublish.vue?vue&type=script&lang=js"
export * from "./JFpublish.vue?vue&type=script&lang=js"

import "./JFpublish.vue?vue&type=style&index=0&id=d860830e&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d860830e"]])

export default __exports__